module.exports = __webpack_public_path__ + "static/img_4470-e5c6c123820c208a53cb7f6225a9d99d.webp";